import { lockScreenScroll } from '../utils/treatment';
import { hideFixedForm } from './actionsForm';

const sidebarFixed = document.querySelector('.js-sidebar-container');
const formMain = document.querySelector('.form-main');
const unitsSelect = document.querySelector('.units-select');

// FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
export function sidebarFixedBehavior(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((menu) => {

    menu.addEventListener('click', () => {

      menu.classList.toggle('open-menu');

      let menuIcon = menu.querySelector('i');
      let menuText = menu.querySelector('span')

      if(menuIcon.classList.contains('icon-menu-esquerda')) {
        menuIcon.classList.add('icon-icon-fechar')
        menuIcon.classList.remove('icon-menu-esquerda')
      } else {
        menuIcon.classList.remove('icon-icon-fechar')
        menuIcon.classList.add('icon-menu-esquerda')
      }

      if(menuText.innerText === 'Menu') {
        menuText.innerHTML = 'Fechar'
      } else {
        menuText.innerHTML = 'Menu'
      }

      if(formMain && formMain.classList.contains('form-content-fixed')) {
        hideFixedForm();
        lockScreenScroll();
      }

      if(unitsSelect && menu.classList.contains('fixed')) {
        sidebarFixed.classList.toggle('fixed');
      }

      sidebarFixed.classList.toggle('d-flex');
      lockScreenScroll();
    });
  });
}

// FUNCTION TO HIDE SIDEBAR FIXED, IF ANOTHER TARGET IS ACTIVE IN DESKTOP
export function hideSidebarFixed(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((menu) => {
    let menuIcon = menu.querySelector('i');
    let menuText = menu.querySelector('span')

    if(menuIcon.classList.contains('icon-menu-esquerda')) {
      menuIcon.classList.add('icon-icon-fechar')
      menuIcon.classList.remove('icon-menu-esquerda')
    } else {
      menuIcon.classList.remove('icon-icon-fechar')
      menuIcon.classList.add('icon-menu-esquerda')
    }

    if(menuText.innerText === 'Menu') {
      menuText.innerHTML = 'Fechar'
    } else {
      menuText.innerHTML = 'Menu'
    }
  });

  sidebarFixed.classList.toggle('d-flex');
}
